<template>
	<router-view />
	<ui-color-mode headless />
	<s-notifications />
</template>